/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable no-case-declarations */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable import/no-cycle */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
import BaseService, {
    CATEGORY_PORTAL,
    ERROR_MESSAGE_TOKEN_INVALID,
    ERROR_MESSAGE_UNEXPECTED,
    HTTP_STATUS_BAD_REQUEST,
    HTTP_STATUS_FORBIDDEN,
    HTTP_STATUS_NO_CONTENT,
    HTTP_STATUS_OK,
    HTTP_STATUS_UNAUTHORIZED,
} from "./core/BaseService";

export interface ChangePasswordPayload {
    authKey: string;
    password: string;
    rePassword: string;
}

class ChangePasswordService extends BaseService {
    constructor() {
        super(CATEGORY_PORTAL, "passwordReminder/changePassword");
    }

    public async changePassword(payload: ChangePasswordPayload, resolved: () => void, rejected: (error: any) => void) {
        await super.postJSON(payload, resolved, rejected);
    }

    protected async errorHandler(response: Response): Promise<Response> {
        const { status } = response;
        if (response.ok && (status === HTTP_STATUS_OK || status === HTTP_STATUS_NO_CONTENT)) {
            return response;
        }

        const json = await response.json();
        switch (status) {
            case HTTP_STATUS_UNAUTHORIZED:
            case HTTP_STATUS_FORBIDDEN:
                throw Error(ERROR_MESSAGE_TOKEN_INVALID);

            case HTTP_STATUS_BAD_REQUEST:
                const message = (json.errors || []).map((e: any) => `${e.detail}`).join("<br/>");
                throw Error(message);

            default:
                throw Error(ERROR_MESSAGE_UNEXPECTED);
        }
    }
}

export default ChangePasswordService;
